import { render, staticRenderFns } from "./AddIDard.vue?vue&type=template&id=6e7eaf25"
import script from "./AddIDard.vue?vue&type=script&lang=js"
export * from "./AddIDard.vue?vue&type=script&lang=js"
import style0 from "./AddIDard.vue?vue&type=style&index=0&id=6e7eaf25&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports